export const aboutData = {
    title: "Who I am",
    description1: "Mohammad Abdullah. I'm a web designer and developer based in Dhaka, Bangladesh.",
    description2: "A self-motivated IT professional with huge knowledge and proficiency in ReactJS,NodeJS, ExpressJS and mobile responsive web development, as well as strong skills and ability in writing clean and efficient code.",
    image: 1
}